import React from 'react'
import backdrop from './BackDrop.module.css'
const BackDrop = (props) => {
    
    return (
        props.show ? <div className={backdrop.backDrop} onClick={props.close}></div> : null
    )
}
export default BackDrop
